export default __webpack_public_path__ + "static/media/ninten.3cf8851e.png";